<template>
	<v-app id="app">
		<v-progress-linear v-if="loginLoading" :indeterminate="true"></v-progress-linear>
		<Menu v-if="isSignedIn && !loginLoading" />
		<Login v-if="!isSignedIn" />
		<router-view v-if="!loginLoading && (isSignedIn || isCallbackRoute)" />
		<UserBadge v-if="isSignedIn && !loginLoading" />
		<StateMessages />
	</v-app>
</template>

<script>
import Menu from '@/components/Menu.vue'
import Login from '@/components/Login.vue'
import StateMessages from '@/components/StateMessages.vue'
import UserBadge from '@/components/UserBadge.vue'
export default {
	name: 'App',
	components: {
		Menu,
		Login,
		StateMessages,
		UserBadge
	},
	data: () => ({}),
	computed: {
		isCallbackRoute() {
			return this.$store.state.isCallbackRoute
		},
		loginLoading() {
			return this.$store.state.loginLoading
		},
		isSignedIn() {
			return !!this.$store.state.user
		}
	},
	mounted() {
		if (window.location.pathname.split('/')[1] == 'callback') {
			this.$store.commit('isCallbackRoute', true)
		}
	},
	methods: {}
}
</script>
